import { QueryHookOptions, useQuery } from '@apollo/client';
import { GET_USER_HAS_SHARES } from '@fintronners/react-api/src';

type useGetUserHasSharesProps = {
  securityId: string;
} & QueryHookOptions;

export const useGetUserHasShares = ({ securityId, ...options }: useGetUserHasSharesProps) => {
  const { data: userShareData, loading: userShareDataLoading } = useQuery(GET_USER_HAS_SHARES, {
    skip: !securityId,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
    variables: {
      securityID: securityId,
    },
    ...options,
  });

  return {
    ...userShareData,
    userShareDataLoading,
  };
};
